

<div style="min-width: none;" [ngClass]="topNavClass">
    <ul class="nav" >
        <li class="nav-item" style="padding-top:00px;">
          <a class="nav-link active" aria-current="true" href="https://{{urlDomain}}/Home/Dashboard">
            <img src="../../../assets/images/SPACE AR small.png" style="height:70px;position:absolute;top:-10px;">
          </a>
        </li>
          <li class="nav-item ms-auto" style="padding-left:30%;padding-top:16px;text-align: right;">
            <span class="topnav-right" style="font-family:Rajdhani;color:white;font-size:20px;">User Name: {{this._appGeneralState.userName}}</span>
          </li>
          <li class="nav-item ms-auto" *ngIf="isUserAdmin()" style="padding-top:9px;">
            <a class="nav-link" href="https://{{urlDomain}}/Admin"><span class="topnav-right" style="font-family:Rajdhani;color:white;font-size:20px;">Admin Home</span></a>
          </li>
          <li class="nav-item ms-auto" style="padding-top:9px;">
            <a class="nav-link" href="https://{{urlDomain}}/Home/LogOff/Auto"><span class="topnav-right" style="font-family:Rajdhani;color:white;font-size:20px;">Logout</span></a>
          </li>
          <li class="nav-item ms-auto" style="padding-top:5px;padding-right:20px;">
            <img src="../../../assets/images/ace-deep-blue-header.png" style="height:40px"/>
          </li>
          
      </ul>
</div>    
<!-- <div class="imageHeader"></div> -->



